<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">{{$t('apiDoc.在线文档')}}</span>
      <!-- 测试工具已屏蔽
      <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{$t('apiDoc.测试工具')}}</span>
      -->
    </div>
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 测试工具已屏蔽
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    -->
  </div>
</template>
<script>
import onlineDoc from "../components/onlineDoc";
// import apiTestDoc from "../components/apiTestDoc";
import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'customs/updateOrder';
export default {
  components: { onlineDoc },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,
      onlineData: {
        apiDesc: `${this.$t('customsDoc.updateOrderDesc')}`,
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList: [
          { title: `${this.$t('onlineDoc.Headers')}`, value: [
              {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
              {name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`},
              {name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`},
          ]},
          { title: `${this.$t('onlineDoc.请求参数')}`, value: [
              {name: "bizContent", type: "String", require: "Y", normal: `${this.$t('onlineDoc.业务参数')}`, describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`},
          ]},
          { title: `${this.$t('onlineDoc.业务参数')}`, value: [
              {name: "customerCode", type: "String", require: "Y", normal: "J0086474299", describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
              {name: "digest", type: "String", require: "Y", normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`, describe: `${this.$t('customsDoc.digestDesc')}`},
              {name: "boxNo", type: "String", require: "Y", normal: "box9999", describe: `${this.$t('customsDoc.boxNo')}`},
              {name: "packageWeight", type: "Number", require: "Y", normal: "", describe: `${this.$t('customsDoc.packageWeight')}`},
              {name: "waybillId", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.waybillOrCustomerOrderId')}`},
              {name: "customerOrderId", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.customerOrderOrWaybillId')}`},
              {name: "estimatedDarf", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('customsDoc.estimatedDarf')}`},
              {name: "estimatedGnre", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('customsDoc.estimatedGnre')}`},
          ]}
        ],
        responseDataList: [
          { title: `${this.$t('onlineDoc.响应参数')}`, value: [
              {name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}`},
              {name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}`},
              {name: "data", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务数据')}`},
          ]}
        ],
        requestCode: `{
    "boxNo": "11111111",
    "customerCode": "J0086024185",
    "digest": "Ue/Bwl4u5PUmtDuMa9VFnQ==",
    "packageWeight": 12,
    "waybillId": "U880001330360911"
}`,
        responseCode: { "code": "1", "msg": "success", "data": false },
        errcodeJson: []
      },
      // apiTestData 已屏蔽
      // apiTestData: { ... }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>@import "../../css/apiTest.scss";</style>